import { render } from "./LiquidationApprovalHistory.vue?vue&type=template&id=609d9430"
import script from "./LiquidationApprovalHistory.vue?vue&type=script&lang=js"
export * from "./LiquidationApprovalHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__